import repository from "@/api/Seguridad.js";

export default {
  obtenerListaUsuarios() {
    let url = `/controlUsuario/Listar`;
    return repository.get(url);
  },
  cargarlistaUsuarios(){
    let url = `/controlUsuario/cargarListaUsuarios`;
    return repository.get(url);
  },
  obtenerUsuario(usuarioId){
    debugger // eslint-disable-line   
    let url = `/controlUsuario/obtenerUsuario/${usuarioId}`;
    return repository.get(url);
  }, 
  desactivarUsuario(usuarioId){
    debugger // eslint-disable-line   
    let url = `/controlUsuario/desactivarUsuario/${usuarioId}`;
    return repository.get(url);
  }, 
  cerrarSesionUsuario(usuarioId){
    debugger // eslint-disable-line   
    let url = `/controlUsuario/cerrarSesionUsuario/${usuarioId}`;
    return repository.get(url);
  }, 
  activarUsuario(usuarioId){
    debugger // eslint-disable-line   
    let url = `/controlUsuario/activarUsuario/${usuarioId}`;
    return repository.get(url);
  }, 
  cargarDatosGenerales() { 
    debugger // eslint-disable-line  
    let url = `/controlUsuario/cargarDatosGenerales`; 
    return repository.get(url);
  },
  cargarRolesDbo(usuarioId,usuarioClonarId){
    debugger // eslint-disable-line  
    let url = `/controlUsuario/cargarRolesDbo/${usuarioId}/${usuarioClonarId}`; 
    return repository.get(url);
  },
  cargarRolesSeguridad(usuarioId,usuarioClonarId){
    debugger // eslint-disable-line  
    let url = `/controlUsuario/cargarRolesSeguridad/${usuarioId}/${usuarioClonarId}`; 
    return repository.get(url);
  },
  cargarAccesosIndividuales(usuarioId,usuarioClonarId){
    debugger // eslint-disable-line  
    let url = `/controlUsuario/cargarAccesosIndividuales/${usuarioId}/${usuarioClonarId}`; 
    return repository.get(url);
  }, 
  
  guardarUsuario(body){ 
    let  url = `/controlUsuario/guardarUsuario`;
    return repository.put(url, body);
  }, 
  asignarRolesDbo(rolesasignados, usuarioId) {
    debugger // eslint-disable-line   
    const url = `/controlUsuario/asignarRolesDbo/${usuarioId}`;
    return repository.put(url, rolesasignados);
  },
  retirarRolesDbo(rolesRetirar, usuarioId) {
      debugger // eslint-disable-line   
      const url = `/controlUsuario/retirarRolesDbo/${usuarioId}`;
      return repository.put(url, rolesRetirar);
  }, 
  asignarRolesSeguridad(rolesasignados, usuarioId) {
    debugger // eslint-disable-line   
    const url = `/controlUsuario/asignarRolesSeguridad/${usuarioId}`;
    return repository.put(url, rolesasignados);
  },
  retirarRolesSeguridad(rolesRetirar, usuarioId) {
      debugger // eslint-disable-line   
      const url = `/controlUsuario/retirarRolesSeguridad/${usuarioId}`;
      return repository.put(url, rolesRetirar);
  }, 
  asignarProcesos(rolesasignados, usuarioId) {
    debugger // eslint-disable-line   
    const url = `/controlUsuario/asignarProcesos/${usuarioId}`;
    return repository.put(url, rolesasignados);
  },
  retirarProcesos(rolesRetirar, usuarioId) {
      debugger // eslint-disable-line   
      const url = `/controlUsuario/retirarProcesos/${usuarioId}`;
      return repository.put(url, rolesRetirar);
  }, 
  asignarPermisos(rolesasignados, usuarioId) {
    debugger // eslint-disable-line   
    const url = `/controlUsuario/asignarPermisos/${usuarioId}`;
    return repository.put(url, rolesasignados);
  },
  retirarPermisos(rolesRetirar, usuarioId) {
      debugger // eslint-disable-line   
      const url = `/controlUsuario/retirarPermisos/${usuarioId}`;
      return repository.put(url, rolesRetirar);
  }

}; 